import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Api_Url } from '../../config/config'
import axios from 'axios'
import { Button, Divider, Modal, Table } from 'antd'
import { ErrorToast, SuccessToast, UpdatedToast } from '../../views/ToastComponent'

function JuiceCeneterdetails() {
    const { id } = useParams()

    const [singleData, setSingleData] = useState([])
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);

    const getSingleUser = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/JuiceShop/item/getallitembyjuiceshopid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setSingleData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        getSingleUser()
    }, [])


    const [juiceCenterData, setJuiceCenterData] = useState({
        juiceShopId: id,
        name: "",
        sale: 0,
        salePrice: 0,
        totalSale: 0,
        grossMargin: 0,
        grossProfit: 0,
        saleDuringPd: 0,
        latitude: "",
        longitude: ""

    })

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setJuiceCenterData({ ...juiceCenterData, latitude: latitude.toString(), longitude: longitude.toString() });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [])

    const handleSubmit = async () => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/JuiceShop/item`, juiceCenterData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
          if (response.data.succeeded) {
            SuccessToast("Added Successfully")
            getSingleUser()
            setIsModalOpen(false)
            handleCancel()
          }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error.message
        }
    }


    const calculateMonthlyRevenue = () => {
        const result = juiceCenterData.salePrice * juiceCenterData.sale || 0;
        setJuiceCenterData(prev => ({
            ...prev,
            totalSale: result,
            grossProfit:(result*juiceCenterData.grossMargin)/100
        }))
    };



    // //   React.useEffect(() => { fetchIncomeData(); fetchAreaType(); fetchCurentLocation(); }, []);

    React.useEffect(() => {
        calculateMonthlyRevenue();
    }, [juiceCenterData.salePrice, juiceCenterData.sale,juiceCenterData.grossMargin]);

    // React.useEffect(() => {
    //     calculatePerMonth();
    // }, [juiceCenterData.salePrice, juiceCenterData.sale]);


    //   Single User Get Api

    // const [juiceEditCenterData, setJuiceEditCenterData] = useState({
    //     juiceShopId: id,
    //     name: "",
    //     sale: 0,
    //     salePrice: 0,
    //     totalSale: 0,
    //     grossMargin: 0,
    //     grossProfit: 0,
    //     saleDuringPd: 0,
    //     latitude: "",
    //     longitude: ""

    // })


    const handleClick = async (id) => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/JuiceShop/item/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }

            })
            setJuiceCenterData(response.data?.data)
            setIsEditModalOpen(true)
        } catch (error) {
            return error.message
        }
    }



    //update Method

    const handleUpdate = async (id) => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/JuiceShop/item/${id}`, juiceCenterData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
        if (response.data.succeeded) {
            UpdatedToast("Successfully Updated")
            setIsEditModalOpen(false)
            getSingleUser()
            handleCancel()
        }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error
        }
    }

    const columns = [
        {
            title: "Name Of Juice",
            dataIndex: "name",
            // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
        },
        {
            title: "Profit Margin",
            dataIndex: "grossMargin",
            // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
        },
        {
            title: "Sale Price/Unit",
            dataIndex: "salePrice",
            // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
        },
        {
            title: "Sale During PD",
            dataIndex: "saleDuringPd",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Gross Profit",
            dataIndex: "grossProfit",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Total Sale",
            dataIndex: "totalSale",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
            render: (text, record) => (
                <div>
                    {text}
                    <Button
                        type="primary"
                        onClick={() => handleClick(record.id)}
                        style={{ marginLeft: '10px' }}
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </Button>
                </div>
            ),
        },
    ];


    async function handleCancel() {
        setJuiceCenterData({
          ...juiceCenterData,
          juiceShopId: id,
          name: "",
          sale: 0,
          salePrice: 0,
          totalSale: 0,
          grossMargin: 0,
          grossProfit: 0,
          saleDuringPd: 0,
  
        })
        setIsModalOpen(false);
        setIsEditModalOpen(false)
      }


    return (

        <>
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="row">
                        <div className="col-12 d-flex align-items-center justify-content-between">
                            <h3 className="mb-0">Juice Assesment</h3>
                            <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsModalOpen(true)}>Add Juice</button>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12 mx-auto">
                            <Table
                                className="table-striped"
                                style={{ overflowX: "auto" }}
                                columns={columns}
                                dataSource={singleData}
                                rowKey={(record) => record.id}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                title={<h4>juice Assesment</h4>}
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                onCancel={() => handleCancel()}
                footer={[
                    <div className='d-flex justify-content-between align-items-center'>
                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
                    </div>
                ]}
                width={600}
                mask={false}
                maskClosable={false}
                closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
                <div className="modal-body mt-5">
                    <form>
                        <Divider>Juice Assesment</Divider>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Juice Name
                                    </label>
                                    <input className="form-control" type="text" placeholder="Juice Name" value={juiceCenterData.name} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, name: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Sale during PD (Units):
                                    </label>
                                    <input className="form-control" type="number" placeholder="Sale during PD (Units):" value={juiceCenterData.saleDuringPd} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, saleDuringPd: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Sale Price (Units):
                                    </label>
                                    <input className="form-control" type="text" placeholder="  Sale Price (Units)" value={juiceCenterData.salePrice} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, salePrice: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Daily Sale (Units):
                                    </label>
                                    <input className="form-control" type="number" placeholder="Daily Sale (Units):" value={juiceCenterData.sale} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, sale: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Profit Margin (%):
                                    </label>
                                    <input className="form-control" type="text" placeholder="Profit Margin (%):" value={juiceCenterData.grossMargin} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, grossMargin: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Daily Reciepts: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {juiceCenterData.totalSale.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Gross Profit: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {juiceCenterData.grossProfit.toFixed(2)}</span>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>

            {/* Edit Modal */}

            <Modal
                title={<h4>juice Assesment</h4>}
                open={isEditModalOpen}
                onOk={() => setIsEditModalOpen(false)}
                onCancel={() => handleCancel()}
                footer={[
                    <div className='d-flex justify-content-between align-items-center'>

                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleUpdate(juiceCenterData.id)}>Update</button>
                    </div>
                ]}
                width={600}
                mask={false}
                maskClosable={false}
                closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
                <div className="modal-body mt-5">
                    <form>
                        <Divider>Juice Assesment</Divider>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Juice Name
                                    </label>
                                    <input className="form-control" type="text" placeholder="Juice Name" value={juiceCenterData.name} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, name: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Sale during PD (Units):
                                    </label>
                                    <input className="form-control" type="number" placeholder="Sale during PD (Units):" value={juiceCenterData.saleDuringPd} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, saleDuringPd: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Sale Price (Units):
                                    </label>
                                    <input className="form-control" type="text" placeholder="  Sale Price (Units)" value={juiceCenterData.salePrice} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, salePrice: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Daily Sale (Units):
                                    </label>
                                    <input className="form-control" type="number" placeholder="Daily Sale (Units):" value={juiceCenterData.sale} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, sale: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Profit Margin (%):
                                    </label>
                                    <input className="form-control" type="text" placeholder="Profit Margin (%):" value={juiceCenterData.grossMargin} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, grossMargin: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Daily Reciepts: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {juiceCenterData.totalSale.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Gross Profit: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {juiceCenterData.grossProfit.toFixed(2)}</span>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    )
}

export default JuiceCeneterdetails
